export default __webpack_public_path__ + "images/de3f732d612934de516ac84c89d7bb90.svg";